import React from "react";
import { MessageBundle } from "@amzn/arb-tools";
import CloudScapeButton from "@cloudscape-design/components/button";
import { TasksPageForm } from "./TasksPageForm";
import {
  usePanelContext,
  PanelContextType,
} from "../../context/PanelContextProvider";
import { USER_ACTIONS } from "../../constants/constants";

export const TASKS_COLUMN_FIELDS_MAP: Map<string, string> = new Map([
  ["taskName", "task_name"],
  ["summary", "summary"],
  ["description", "description"],
  ["severity", "severity"],
  ["dueDate", "due_date"],
  ["tags", "tags"],
  ["active", "active"],
  ["issueTitle", "issue_title"],
  ["lastUpdated", "last_updated"],
  ["updatedBy", "updated_by"],
]);

const ROW_HEADER = "taskName";

export const getTasksPageTableColumnDefinition = (bundle: MessageBundle) => {
  const panelContext: PanelContextType | undefined = usePanelContext();

  return Array.from(TASKS_COLUMN_FIELDS_MAP.entries()).map(([key, value]) => {
    if (key === ROW_HEADER) {
      return {
        id: key,
        header: bundle.getMessage(value),
        cell: (item: any) => (
          <CloudScapeButton
            variant="inline-link"
            onClick={() => {
              panelContext!.setSplitPanelContent(
                <TasksPageForm
                  taskRecord={item}
                  panelContext={panelContext!}
                  panelType={USER_ACTIONS.EDIT}
                />
              );
              panelContext!.setSplitPanelOpen(true);
            }}
          >
            {item[key]}
          </CloudScapeButton>
        ),
        sortingField: key,
        isRowHeader: true,
      };
    }
    return {
      id: key,
      header: bundle.getMessage(value),
      cell: (item: any) => item[key],
      sortingField: key,
    };
  });
};
